import badRequest from './400.bad-request'
import authRequired from './401.auth-required'
import paymentRequired from './402.payment-required'
import forbidden from './403.forbidden'
import notFound from './404.not-found'
import requestTimeout from './408.request-timeout'
import payloadTooLarge from './413.payload-too-large'
import rateLimitExceeded from './429.rate-limit-exceeded'
import internalServerError from './500.internal-server-error'
import serviceUnavailable from './503.service-unavailable'
import { IDDErrorHandlerErrorList } from '../dd-error-handler.types'

export default {
  400: badRequest,
  401: authRequired,
  402: paymentRequired,
  403: forbidden,
  404: notFound,
  408: requestTimeout,
  413: payloadTooLarge,
  429: rateLimitExceeded,
  500: internalServerError,
  503: serviceUnavailable,
} as IDDErrorHandlerErrorList
